module.exports = __webpack_public_path__ + "img/icon_utill_cn.08187b23.svg";